module.exports = "<div style=\"margin-left: 47%;\">\n  <i class=\"fa fa-spinner fa-spin\" style=\"font-size:72px;\"></i>\n</div>\n\n<!-- *ngIf=\"responseStatus!='cancel'\"-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/buyer/checkout/checkout.component.html
// module id = 538
// module chunks = 0